export default "__VITE_ASSET__C9y8zHQi__"